<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte General</v-toolbar-title>
              <v-divider class="mx-4" vertical></v-divider>
              <v-btn color="#FC8333" text outlined @click="showParams = !showParams">
                  <div v-if="!showParams">Ver Parametros <v-icon>mdi-arrow-right</v-icon></div>
                  <div v-else>Ocultar Parametros <v-icon>mdi-arrow-left</v-icon></div>
               </v-btn>
               <v-divider class="mx-4" vertical></v-divider>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical class="mx-4"></v-divider>
                   <v-select
                        v-model="selectedHeaders"
                        label="Campos del Reporte"
                        :items="headers"
                        append-icon="mdi-format-columns"
                        return-object
                        clearable
                        filled
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 2" x-small color="#FC8333" text-color="black">
                                <span>{{ item.text }}</span>
                            </v-chip>
                            <span v-if="index === 2" class="grey--text caption">(+{{ selectedHeaders.length - 2 }} otros)</span>
                        </template>
                    </v-select>
                    <v-divider class="mx-4" vertical></v-divider>
                    <v-btn icon x-large @click="exportToExcel()"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                    <v-divider class="mx-4" vertical></v-divider>
               </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row dense>
                <v-col cols="12" sm="12" md="3" v-if="showParams">
                    <v-card>
                        <v-card-subtitle>Parametros</v-card-subtitle>
                        <v-card-text>
                          <v-row dense>
                              <v-radio-group row label="Fecha de Reporte:" v-model="fechaRep">
                                <v-radio :value="0" label="Creación"></v-radio>
                                <v-radio :value="1" label="Pickup"></v-radio>
                                <v-radio :value="2" label="Arribo"></v-radio>
                                <v-radio :value="3" label="Liberacion Aduana"></v-radio>
                              </v-radio-group>
                          </v-row>
                            <v-row dense>
                                <v-col>
                                    <v-text-field v-model="desde" type="date" clearable label="Desde"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="hasta" type="date" clearable label="Hasta"></v-text-field>
                                </v-col>
                            </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="tipo"
                                    label="Tipo"
                                    :items="tipos"
                                    append-icon="filter"
                                    item-value="cod"
                                    item-text="tipo"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="tipo ? tipo.tipo == 'Nacional' : false" dense>
                            <v-col>
                                <v-combobox
                                    v-model="ciudadO"
                                    label="Ciudad Origen"
                                    :items="ciudades"
                                    append-icon="mdi-map-marker"
                                    item-value="ciudad"
                                    item-text="ciudad"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="tipo ? tipo.tipo == 'Nacional' : false" dense>
                            <v-col>
                                <v-combobox
                                    v-model="ciudadD"
                                    label="Ciudad Destino"
                                    :items="ciudades"
                                    append-icon="mdi-map-marker"
                                    item-value="ciudad"
                                    item-text="ciudad"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="estatus"
                                    label="Estatus"
                                    :items="estatuses"
                                    append-icon="mdi-sticker-check"
                                    item-value="id"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="agente"
                                    label="Agentes"
                                    :items="agentes"
                                    append-icon="mdi-handshake"
                                    item-value="id"
                                    item-text="nombre"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-combobox
                                    v-model="pendfin"
                                    label="Pendientes / Finalizadas"
                                    :items="pendfines"
                                    append-icon="mdi-playlist-check"
                                    item-value="cod"
                                    item-text="descripcion"
                                    return-object
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        </v-card-text>
                        <v-card-actions dense>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark outlined @click="getData()">Generar <v-icon>mdi-file</v-icon></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" :md="showParams ? '9' : '12'">
                    <v-card>
                        <v-card-subtitle>Reporte</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="showHeaders" :items="guias" :search="searcher">
                                        <template v-slot:item.direccion_c="{ item }">
                                            {{item.direccion1_c + ' ' + item.direccion2_c + ' ' + (item.direccion3_c != null ? item.direccion3_c : '')}}
                                        </template>
                                        <template v-slot:item.direccion_e="{ item }">
                                            {{item.direccion1_e + ' ' + item.direccion2_e + ' ' + (item.direccion3_e != null ? item.direccion3_e : '')}}
                                        </template>
                                        <template v-slot:item.cargosadicionales="{ item }">
                                            <span v-for="(ca,index) in item.cargosadicionales" :key="index">{{ca.cargo.cargo + (ca.observacion != null ? '(' + ca.observacion + ')': '') + '=$' + ca.valor + ', '}} </span>
                                        </template>
                                        <template v-slot:item.totalcargos="{ item }">
                                            ${{item.cargosadicionales.reduce((sumv, itemv) => sumv + parseFloat(itemv.valor),0)}}
                                        </template>
                                        <template v-slot:item.reclamos="{ item }">
                                            <span v-for="(re,index) in item.reclamoslst" :key="index">{{(re.causal != null ? re.causal.causal : '') + (re.estado != null ? '(' + re.estado.estado + ')' : '') + ', '}}</span>
                                        </template>
                                        <template v-slot:item.estatuslist="{ item }">
                                            <span v-for="(el,index) in item.estatuslist" :key="index">{{formatDate(el.fecha) + (el.estatus != null ? '(' + el.estatus.descripcion + ')(' + el.comentarios + ')' : '') + ', '}}</span>
                                        </template>

                                        <template v-slot:item.motivoundel="{ item }">
                                            <span v-for="(mu,index) in item.motivosundellist" :key="index">{{(mu.motivo != null ? mu.motivo.motivo : '') + (mu.observacion != null ? '(' + mu.observacion + ')': '') + ', '}}</span>
                                        </template>
                                        <template v-slot:item.rpppeso="{ item }">
                                            {{item.paquetes.reduce((sumv, itemv) => sumv + parseFloat(itemv.pesototal_r != null ? itemv.pesototal_r : 0),0)}}
                                        </template>
                                        <template v-slot:item.rppmedidas="{ item }">
                                            <span v-for="(rpm,index) in item.paquetes" :key="index">{{rpm.largo_r != null ? (rpm.largo_r + 'X' + rpm.ancho_r + 'X' + rpm.alto_r + ', ') : ''}}</span>
                                        </template>
                                        <template v-slot:item.medidas="{ item }">
                                            <span v-for="(m,index) in item.paquetes" :key="index">{{m.largo != null ? (m.largo + 'X' + m.ancho + 'X' + m.alto + ', ') : ''}}</span>
                                        </template>
                                        <template v-slot:item.created_at="{ item }">
                                            {{formatDate(item.created_at)}}
                                        </template>
                                        <template v-slot:item.fecha_estatus="{ item }">
                                          {{
                                            item.ultimoestatus != null
                                              ? formatDate(
                                                  item.ultimoestatus.fecha + 'T00:00:00Z'
                                                )
                                              : null
                                          }}
                                        </template>
                                        <template v-slot:item.ultimo_estatus="{ item }">
                                          {{
                                            item.ultimoestatus != null
                                              ? item.ultimoestatus.estatus.descripcion
                                              : null
                                          }}
                                        </template>
                                        <template v-slot:item.comentario_estatus="{ item }">
                                         {{
                                            item.ultimoestatus != null
                                              ? item.ultimoestatus.comentarios
                                              : null
                                        }}
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data() {
    return{
        showParams: true,
        desde: null,
        hasta: null,
        searcher: null,
        fechaRep: 0,
        tipos: [
            { tipo: "Importación", cod: "importacion" },
            { tipo: "Exportación", cod: "exportacion" },
            { tipo: "Nacional", cod: "nacional" },
        ],
        tipo: null,
        estatuses: [],
        estatus: null,
        agentes: [],
        agente: null,
        pendfines: [
            {descripcion: 'Pendientes', cod: 'P'},
            {descripcion: 'Finalizadas', cod: 'F'},
        ],
        pendfin: null,
        ciudades: [],
        ciudadO: null,
        ciudadD: null,
        guias: [],
        headers: [
            { text: "Fecha Ingreso AWB", value: "created_at", sortable: false },
            { text: "Fecha Pickup", value: "fecha_pickup", sortable: false },
            { text: "Fecha UNDEL", value: "undel_fecha", sortable: false },
            { text: "Motivo UNDEL", value: "motivoundel", sortable: false },
            { text: "Solución", value: "undel_solucion", sortable: false },
            { text: "Fecha Solución", value: "undel_fechasolucion", sortable: false },
            { text: "Fecha Salida", value: "fecha_salida", sortable: false },
            { text: "Fecha Arribo", value: "fecha_arribo", sortable: false },
            { text: "Fecha Entrega", value: "podfecha", sortable: false },
            { text: "Persona que Recibio", value: "podnombre", sortable: false },
            { text: "PU Reference Schedule", value: "pu_reference_shedule", sortable: false },
            { text: "AWB INEX", value: "guia_interna", sortable: false },
            { text: "Operador", value: "proveedor", sortable: false },
            { text: "AWB Operador", value: "guia_proveedor", sortable: false },
            { text: "Via", value: "via", sortable: false },
            { text: "Facturar a", value: "clientefacturar.empresa", sortable: false },
            { text: "Empresa (Receiver)", value: "empresa_c", sortable: false },
            { text: "Contacto (Receiver)", value: "contacto_c", sortable: false },
            { text: "Vat Num (Receiver)", value: "nit_c", sortable: false },
            { text: "Email (Receiver)", value: "correo_c", sortable: false },
            { text: "Dirección (Receiver)", value: "direccion_c", sortable: false },
            { text: "Ciudad (Receiver)", value: "ciudad_c", sortable: false },
            { text: "ZIP (Receiver)", value: "zip_c", sortable: false },
            { text: "Teléfono (Receiver)", value: "telefono_c", sortable: false },
            { text: "País (Receiver)", value: "pais_c", sortable: false },
            { text: "Empresa (Sender)", value: "empresa_e", sortable: false },
            { text: "Contacto (Sender)", value: "contacto_e", sortable: false },
            { text: "Vat Num (Sender)", value: "nit_e", sortable: false },
            { text: "Email (Sender)", value: "correo_e", sortable: false },
            { text: "Dirección (Sender)", value: "direccion_e", sortable: false },
            { text: "Ciudad (Sender)", value: "ciudad_e", sortable: false },
            { text: "ZIP (Sender)", value: "zip_e", sortable: false },
            { text: "Teléfono (Sender)", value: "telefono_e", sortable: false },
            { text: "País (Sender)", value: "pais_e", sortable: false },
            { text: "Descripción", value: "descripcion", sortable: false },
            { text: "Piezas", value: "piezas", sortable: false },
            { text: "Peso (kgs)", value: "peso", sortable: false },
            { text: "Medidas (cm)", value: "medidas", sortable: false },
            { text: "Valor Declarado", value: "valor", sortable: false },
            { text: "Moneda", value: "moneda", sortable: false },
            { text: "Incoterm", value: "termino", sortable: false },
            { text: "Referencia del Cliente", value: "referencia_cliente", sortable: false },
            { text: "Seguro", value: "seguro", sortable: false },
            { text: "Valor Contenido", value: "seg_valor_contenido", sortable: false },
            { text: "Flete Int", value: "seg_flete_int", sortable: false },
            { text: "Flete Nac", value: "seg_flete_nac", sortable: false },
            { text: "Valor Total Seguro", value: "seg_valor_total", sortable: false },
            { text: "No Aplicación", value: "seg_no_aplicacion", sortable: false },
            { text: "Cargos Adicionales", value: "cargosadicionales", sortable: false },
            { text: "Total Cargos", value: "totalcargos", sortable: false },
            { text: "Régimen", value: "regimen", sortable: false },
            { text: "Estatus", value: "ultimo_estatus", sortable: false },
            { text: "Fecha Estatus", value: "fecha_estatus", sortable: false },
            {
              text: "Comentario Estatus",
              value: "comentario_estatus",
              sortable: false,
            },
            { text: "Arribo en", value: "arribo_en", sortable: false },
            { text: "Tipo de Persona", value: "tipo_persona", sortable: false },
            { text: "Origen", value: "origen_per", sortable: false },
            { text: "Cliente Operador Postal", value: "cliente_operador_postal", sortable: false },
            { text: "Reclamos", value: "reclamos", sortable: false },
            { text: "RPP Peso", value: "rpppeso", sortable: false },
            { text: "RPP Medidas", value: "rppmedidas", sortable: false },
            { text: "Valor Declarado Aduana", value: "valor_declarado_aduana", sortable: false },
            { text: "Fecha de Envío de Datos al Agente", value: "fecha_envio_datos_agente", sortable: false },
            { text: "Fecha de Declaración", value: "fecha_declaracion", sortable: false },
            { text: "Fecha de Pago de Impuesto", value: "fecha_pago_imp", sortable: false },
            { text: "Fecha de Liberación Aduana", value: "fecha_liberacion_aduana", sortable: false },
            { text: "Observaciones", value: "observaciones", sortable: false },
            { text: "Historial Estatus", value: "estatuslist", sortable: false },
        ],
        selectedHeaders: [],
        isCliente: false,
    }
},
methods:{
    getEstatuses: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'estatusall').then((result) => {
            this.estatuses = result
        }).catch((err) => {
            console.log(err);
        })
    },
    getAgentes: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'agente').then((result) => {
            this.agentes = result;
            this.agentes.push({id: 0, nombre: 'DHL'});
            this.agentes.push({id: 1000, nombre: 'UPS'});
            this.agentes.push({id: 1001, nombre: 'Vinculados'});
            this.agentes.push({id: 1002, nombre: 'No Vinculados'});
        }).catch((err) => {
            console.log(err);
        })
    },
    getCiudades: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'ciudadesec').then((result) => {
            this.ciudades = result;
        }).catch((err) =>{
            console.log(err);
        })
    },
    getData: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reportegeneral',{
            fechaRep: this.fechaRep,
            desde: this.desde,
            hasta : this.hasta,
            tipo: this.tipo != null ? this.tipo.tipo : null,
            ciudadO: this.ciudadO != null ? this.ciudadO.ciudad : null,
            ciudadD: this.ciudadD != null ? this.ciudadD.ciudad : null,
            estatus: this.estatus != null ? this.estatus.id : null,
            agente: this.agente != null ? this.agente.nombre : null,
            pendfin: this.pendfin != null ? this.pendfin.cod : null,
            }).then((result) => {
            this.guias = result;
            this.showParams = false;
        }).catch((err) => {
            console.log(err);
        });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.guias.map(rec => {
            let obj = {
                'Fecha Ingreso AWB' :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),
                'Fecha Pickup': rec.fecha_pickup != null ? new Date(rec.fecha_pickup + 'T00:00:00') : '',
                "Fecha UNDEL": rec.undel_fecha != null ? new Date(rec.undel_fecha + 'T00:00:00') : '',
                "Motivo UNDEL": rec.motivosundellist.reduce((pv,cv) => pv + (cv.motivo != undefined ? cv.motivo.motivo : '') + (cv.observacion != null ? '(' + cv.observacion + '), ' : ','),""),
                "Solución": rec.undel_solucion,
                "Fecha Solución": rec.undel_fechasolucion,
                "Fecha Salida": rec.fecha_salida,
                "Fecha Arribo": rec.fecha_arribo != null ? new Date(rec.fecha_arribo + 'T00:00:00') : '',
                "Fecha Entrega": rec.podfecha != null ? new Date(rec.podfecha + 'T00:00:00') : '',
                "Persona que Recibio": rec.podnombre,
                "PU Reference Schedule": rec.pu_reference_shedule,
                "AWB INEX": rec.guia_interna,
                "Operador": rec.proveedor,
                "AWB Operador": rec.guia_proveedor,
                "Via": rec.via,
                "Facturar a": rec.clientefacturar != undefined ? rec.clientefacturar.empresa: '',
                "Empresa (Receiver)": rec.empresa_c,
                "Contacto (Receiver)": rec.contacto_c,
                "Vat Num (Receiver)": rec.nit_c,
                "Email (Receiver)": rec.correo_c,
                "Dirección (Receiver)": rec.direccion1_c + ' ' + rec.direccion2_c + ' ' + (rec.direccion3_c != null ? rec.direccion3_c : ''),
                "Ciudad (Receiver)": rec.ciudad_c,
                "ZIP (Receiver)": rec.zip_c,
                "Teléfono (Receiver)": rec.telefono_c,
                "País (Receiver)": rec.pais_c,
                "Empresa (Sender)": rec.empresa_e,
                "Contacto (Sender)": rec.contacto_e,
                "Vat Num (Sender)": rec.nit_e,
                "Email (Sender)": rec.correo_e,
                "Dirección (Sender)": rec.direccion1_e + ' ' + rec.direccion2_e + ' ' + (rec.direccion3_e != null ? rec.direccion3_e : ''),
                "Ciudad (Sender)": rec.ciudad_e,
                "ZIP (Sender)": rec.zip_e,
                "Teléfono (Sender)": rec.telefono_e,
                "País (Sender)": rec.pais_e,
                "Descripción": rec.descripcion,
                "Piezas": rec.piezas,
                "Peso (kgs)": rec.peso,
                "Medidas (cm)": rec.paquetes.reduce((pv,cv) => pv + (cv.largo != null ? (cv.largo + 'X' + cv.ancho + 'X' + cv.alto + ',') : ''),""),
                "Valor Declarado": rec.valor,
                "Moneda": rec.moneda,
                "Incoterm": rec.termino,
                "Referencia del Cliente": rec.referencia_cliente,
                "Seguro": rec.seguro,
                "Valor Contenido": rec.seg_valor_contenido,
                "Flete Int": rec.seg_flete_int,
                "Flete Nac": rec.seg_flete_nac,
                "Valor Total Seguro": rec.seg_valor_total,
                "No Aplicación": rec.seg_no_aplicacion,
                'Cargos Adicionales': rec.cargosadicionales.reduce((pv, cv) => pv + cv.cargo.cargo + (cv.observacion != null ? '(' + cv.observacion + ')' : '') + '=$' + cv.valor + ', ' ,""),
                'Total Cargos': rec.cargosadicionales.reduce((sumv, itemv) => sumv + parseFloat(itemv.valor),0),
                "Régimen": rec.regimen,
                "Estatus": rec.ultimoestatus != null ? rec.ultimoestatus.estatus.descripcion : '',
                "Fecha Estatus":
                          rec.ultimoestatus != null
                            ?
                            this.formatDate(rec.ultimoestatus.fecha + 'T00:00:00Z')
                            : null
                        ,
                "Comentario Estatus":  rec.ultimoestatus != null
                            ? rec.ultimoestatus.comentarios
                            : null,
                "Arribo en": rec.arribo_en,
                "Tipo de Persona": rec.tipo_persona,
                "Origen": rec.origen_per,
                "Cliente Operador Postal": rec.cliente_operador_postal,
                "Reclamos": rec.reclamoslst.reduce((pv,cv) => pv + (cv.causal != undefined ? cv.causal.causal : '') + (cv.estado != undefined ? '(' + cv.estado.estado + '),' : ''),""),
                "RPP Peso": rec.paquetes.reduce((sumv,itemv) => sumv + parseFloat(itemv.pesototal_r != null ? itemv.pesototal_r : 0),0),
                "RPP Medidas": rec.paquetes.reduce((pv,cv) => pv + (cv.largo_r != null ? (cv.largo_r + 'X' + cv.ancho_r + 'X' + cv.alto_r + ',') : ''),""),
                "Valor Declarado Aduana": rec.valor_declarado_aduana,
                "Fecha de Envío de Datos al Agente": rec.fecha_envio_datos_agente != null ? new Date(rec.fecha_envio_datos_agente + 'T00:00:00') : '',
                "Fecha de Declaración": rec.fecha_declaracion != null ? new Date(rec.fecha_declaracion + 'T00:00:00') : '',
                "Fecha de Pago de Impuesto": rec.fecha_pago_imp != null ? new Date(rec.fecha_pago_imp + 'T00:00:00') : '',
                "Fecha de Liberación Aduana": rec.fecha_liberacion_aduana != null ? new Date(rec.fecha_liberacion_aduana + 'T00:00:00') : '',
                "Observaciones": rec.observaciones,
                "Historial Estatus" : rec.estatuslist.reduce((pv,cv) => pv + this.formatDate(cv.fecha) + (cv.estatus != undefined ? '(' + cv.estatus.descripcion + ')(' + cv.comentarios + '), ' : ''),""),
            }
            //Eliminar las columnas no seleccionadas
            Object.keys(obj).forEach((key) => {
                const found = this.selectedHeaders.some(el => el.text === key);
                if(!found){
                    delete obj[key]
                }
            })
            return obj;
        });
        let data = XLSX.utils.json_to_sheet(newJson);
        const workbook = XLSX.utils.book_new();
        const filename = 'Reporte General';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
computed:{
    showHeaders () {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
},
mounted: function(){
    apicon.setAuthHeaders();
    this.getEstatuses();
    this.getAgentes();
    this.getCiudades();
    this.selectedHeaders = this.headers;
    this.isCliente = localStorage.getItem("cliente");
}
}
</script>
